export function getPricePosition({ price, minPrice, maxPrice, min = 80 }) {
  const pricePositionRaw = ((price - minPrice) / (maxPrice - minPrice)) * 100;
  return Math.min(min, pricePositionRaw);
}
